'use client'

import Fade from 'embla-carousel-fade'
import { type MouseEvent, useEffect, useState } from 'react'

import { Carousel, Image } from '@/shared/ui'

import { ImageGallery } from '../image-gallery'
import { DEFAULT_SELECTED_IMAGE_INDEX } from '../image-gallery/image-list'

type Props = {
  roomId: number
  like: boolean
  images: string[]
  roomName: string
  roomUrl: string | null
  className?: string
  showLikeButton?: boolean
}

export const RoomImageCarousel = ({
  roomId,
  like,
  images,
  roomName,
  roomUrl,
  className,
  showLikeButton = true,
}: Props) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(
    DEFAULT_SELECTED_IMAGE_INDEX,
  )

  const isGalleryOpen = selectedImageIndex !== DEFAULT_SELECTED_IMAGE_INDEX

  const handleClose = () => {
    document.body.classList.remove('fixed-body')
    document.documentElement.style.overflow = 'auto'
  }

  const handleThumbnailClick = (index: number) => {
    setSelectedImageIndex(index)
    document.body.classList.add('fixed-body')
    document.documentElement.style.overflow = 'hidden'
  }

  const handleGalleryClose = () => {
    setSelectedImageIndex(DEFAULT_SELECTED_IMAGE_INDEX)
    setTimeout(handleClose, 500)
  }

  const handleContextMenu = (event: MouseEvent<HTMLImageElement>) => {
    event.preventDefault()
  }

  useEffect(() => {
    return () => {
      handleClose()
    }
  }, [])

  return (
    <>
      <Carousel.Provider
        orientation="horizontal"
        options={{ loop: true }}
        plugins={[Fade()]}
        className={className}
      >
        <Carousel.Root className="w-[710px]">
          <Carousel.Content>
            {images.map((image, index) => (
              <Carousel.Item key={image}>
                <Image
                  src={image}
                  alt={roomName}
                  width={710}
                  height={473}
                  className="cursor-pointer rounded-sm select-none"
                  placeholder
                  onClick={() => {
                    handleThumbnailClick(index)
                  }}
                  onContextMenu={handleContextMenu}
                />
              </Carousel.Item>
            ))}
          </Carousel.Content>
          <Carousel.SnapDisplay />
        </Carousel.Root>
        <Carousel.Thumbnails
          images={images}
          alt={roomName}
          className="mt-5"
          onClick={handleThumbnailClick}
        />
      </Carousel.Provider>
      <ImageGallery
        open={isGalleryOpen}
        onClose={handleGalleryClose}
        selectedIndex={selectedImageIndex}
        roomId={roomId}
        like={like}
        images={images}
        roomName={roomName}
        roomUrl={roomUrl}
        showLikeButton={showLikeButton}
      />
    </>
  )
}
